module.exports = __webpack_public_path__ + "media/images/hapier/conceito_hapier-7429e68f012ee7e3aee01e7753ff1ff8.png";